function learnActions(backendAxiosInstance) {
  function searchResult(searchResultParams) {
    return backendAxiosInstance.post(
      "/experiences/v4/LearnActions/searchresult",
      searchResultParams,
      {
        includeTimeZone: true,
        includeClientType: true
      }
    );
  }
  return {
    searchResult
  };
}

export { learnActions as default };
//# sourceMappingURL=learnActions.js.map
